export default [
  {
    action: "read",
    icon: 'HomeIcon',
    title: 'Dashboard',
    route: "admin-home",
    tagVariant: 'light-warning',
  },
  {
    action: "read",
    title: 'Consultations',
    icon: 'HeadphonesIcon',
    tagVariant: 'light-warning',
    route: "admin-consultations",
    permissions: ["pharmacy_consultations:CanList"],
  },
  {
    title: 'Notifications',
    action: "read",
    icon: 'MailIcon',
    route: "admin-notifications",
    tagVariant: 'light-primary',
    permissions: ["notifications:CanList"],
  },
  {
    title: 'Reports',
    icon: 'BookIcon',
    children: [
      {   
        title: 'Patients Seen',
        icon: 'UserIcon',
        route: "admin-patients-seen-reports",
        permissions: ["pharmacy_patients_seen_reports:CanList"]
      },
      {
        action: "read",
        title: 'Consultation',
        icon: 'HeadphonesIcon',
        route: "admin-consultation-reports",
        permissions: ["pharmacy_consultations_reports:CanList"]
      },
      {
        action: "read",
        title: 'Medication',
        icon: 'ThermometerIcon',
        route: "admin-medication-reports",
        permissions: ["pharmacy_medication_reports:CanList"]
      },
    ],
    childrenNestedRoutes: [
      "pharmacy_patients_seen_reports:CanList",
      "pharmacy_consultations_reports:CanList", 
      "pharmacy_medication_reports:CanList"
    ]
  },
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    children: [
      {
        action: "read",
        title: 'General',
        icon: 'SettingsIcon',
        route: "admin-settings",
        permissions: ["settings:CanList"]
      },
      {
        action: "read",
        title: 'ICD-10 Codes',
        icon: 'AlertTriangleIcon',
        route: "admin-icd-10-medical-codes",
        permissions: ["icd_10_diagnosis_codes:CanList"]
      },
      {
        action: "read",
        title: 'Cancer Types',
        icon: 'AwardIcon',
        route: "admin-cancer-types",
        permissions: ["cancer_types:CanList"]
      },
      {
        action: "read",
        title: 'Common Complaints',
        icon: 'AlertOctagonIcon',
        route: "admin-common-complaints",
        permissions: ["common_complaints:CanList"]
      },
      {
        action: "read",
        title: 'Direct Questions',
        icon: 'HelpCircleIcon',
        route: "admin-direct-questions",
        permissions: ["direct_questions:CanList"]
      },
      {
        title: 'Drugs',
        icon: 'ThermometerIcon',
        children: [
          {
            action: "read",
            title: 'List',
            route: "admin-drugs",
            permissions: ["drugs:CanList"]
          },
          {
            action: "read",
            title: 'Concentrations',
            route: "admin-drug-concentration",
            permissions: ["drug_concentrations:CanList"]
          },
          {
            action: "read",
            title: 'Formulations',
            route: "admin-drug-formulation",
            permissions: ["drug_formulations:CanList"]
          },
          {
            action: "read",
            title: 'Routes',
            route: "admin-drug-routes",
            permissions: ["drug_routes:CanList"]
          },
          {
            action: "read",
            title: 'Dose Frequency',
            route: "admin-drug-dose-frequency",
            permissions: ["drug_dose_frequency:CanList"]
          },
        ]
      },
    ],
    childrenNestedRoutes: []
  },
  {
    title: 'Administration',
    icon: 'MinusCircleIcon',
    tagVariant: 'light-warning',
    children: [
      {
        action: "read",
        icon: 'BoxIcon',
        title: 'Resources',
        route: "admin-resources",
        tagVariant: 'light-warning',
        permissions: ["resource:CanList"],
      },
      {
        action: "read",
        icon: 'LockIcon',
        title: 'Policies',
        route: "admin-policies",
        tagVariant: 'light-warning',
        permissions: ["policy:CanList"],
      },
      {
        title: 'Roles',
        action: "read",
        icon: 'LockIcon',
        route: "admin-user-roles",
        tagVariant: 'light-warning',
        permissions: ["user_role:CanList"],
      },
      {
        title: 'Users',
        route: "admin",
        action: "read",
        icon: 'UserPlusIcon',
        tagVariant: 'light-warning',
        permissions: ["admin:CanList"],
        childrenNestedRoutes: [
          'add-administrator',
          'admin-single',
        ]
      },
    ],
    childrenNestedRoutes: [
      'admin-new-user',
      'admin-single',
      'add-administrator',

      'admin-resources',
      'admin-new-resources',
      'admin-update-resource',
      'admin-resource-actions',
      'admin-new-resource-action',
      'admin-update-resource-action',
      'admin-policies',
      'admin-new-policy',
      'admin-user-roles',
      'admin-view-policies',
      'admin-new-user-role',
      'admin-update-patient-role',
    ]
  },
  {
    title: 'Logs',
    icon: 'ListIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Logs',
        action: "read",
        icon: 'ListIcon',
        route: "admin-logs",
        tagVariant: 'light-warning',
        permissions: ["admin_logs:CanList"]
      },
      {
        title: 'Audit Trail',
        action: "read",
        route: "audit-trail",
        icon: 'GitBranchIcon',
        tagVariant: 'light-warning',
        permissions: ["audit_trail:CanList"]
      },
    ],
    childrenNestedRoutes: [
      'admin-logs',
      'user-logs',
      'audit-trail'
    ]
  },
]
